export class InvalidStringValueObject extends Error {
  static fromValue(value) {
    return new this(`Invalid value for StringValueObject: ${value}, typeof: ${typeof value}`);
  }
}
